export const getStyles = () => ({
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
  },
  editor: {
    width: '600px',
    minWidth: '600px',

    '& .ad-text-panel': {
      '& > div + div': {
        marginTop: '16px',
      },

      '& .field-label': {
        padding: '5px 0',
      },

      '& .text-input-container': {
        width: 'auto',
      },

      '& .url-path-container > label': {
        display: 'none',
      },
    },

    '& .error': {
      color: '#A80000',
    },
  },
  preview: {

  },
});
